import formatNumber from './format-number';

export default (value: number, precision = 0): string => `${formatNumber(value * 100, precision)}%`;
